// 画面のログを「保存できるテキスト」にする。DOM に触らないので単体テストできる。
//
// クライアント側のログはブラウザのメモリにしか無く、ページを閉じれば消える（サーバには
// 送っていない。受信統計を返す制御メッセージが無い。DOC-0021 §9）。試聴の記録（#41）で
// 「そのとき回線がどうだったか」を後から確かめられるよう、テキストに落として保存する。

/** 見出しに付ける「項目: 値」。並ぶ順に意味があるので配列で持つ。 */
export type LogMeta = [string, string][];

/** 保存するテキストの行数の上限。これを超えたら古いほうから捨てる（メモリを食い続けないため）。 */
export const MAX_RECORDED_LINES = 5000;

/** ローカル時刻の `YYYY-MM-DD HH:MM:SS`。 */
export function localTimestamp(now: Date): string {
  const p = (n: number) => String(n).padStart(2, "0");
  return (
    `${now.getFullYear()}-${p(now.getMonth() + 1)}-${p(now.getDate())} ` +
    `${p(now.getHours())}:${p(now.getMinutes())}:${p(now.getSeconds())}`
  );
}

/** 保存するファイル名。例: `telephone-20261001-1030.txt` */
export function logFileName(now: Date): string {
  const p = (n: number) => String(n).padStart(2, "0");
  return (
    `telephone-${now.getFullYear()}${p(now.getMonth() + 1)}${p(now.getDate())}` +
    `-${p(now.getHours())}${p(now.getMinutes())}.txt`
  );
}

/**
 * 見出し + ログ本文のテキストを作る。
 *
 * 見出しを付けるのは、**どの端末・どの部屋・どの設定で取ったログか**が分からないと
 * 後から比べられないため（試聴の記録は条件とセットで意味を持つ）。
 */
export function buildLogText(now: Date, meta: LogMeta, lines: string[]): string {
  const head = [
    "# TELEPHONE-SYSTEM クライアントのログ",
    `保存時刻: ${localTimestamp(now)}`,
    // 見出しは「保存した瞬間の画面」なので、通話ごとの設定とは食い違うことがある
    // （最初は SFU で、保存時は MCU を選んでいた等。2026-10-01 のログで実際に起きた）
    "※ 下の「接続先・方式・部屋・設定」は保存した時点の画面の状態。通話ごとの設定は本文の「入室しました」「設定:」の行を見る",
    "-".repeat(40),
    ...meta.map(([k, v]) => `${k}: ${v}`),
    `行数: ${lines.length}${lines.length >= MAX_RECORDED_LINES ? "（上限に達したので古い行は捨てられています）" : ""}`,
  ];
  return `${head.join("\n")}\n\n${lines.join("\n")}\n`;
}
